import { axiosInstance } from '../request';
export const getMemoryClusters = async () => {
    const response = await axiosInstance.get('/api/v1/memories/clusters');
    return response.data;
};
export const getMemoryFacts = async (params = {}) => {
    const response = await axiosInstance.get('/api/v1/memories/facts', { params });
    return response.data;
};
export const deleteMemoryFact = async (factId) => {
    await axiosInstance.delete(`/api/v1/memories/facts/${factId}`);
};
export const rebuildMemories = async () => {
    await axiosInstance.post('/api/v1/memories/rebuild');
};
//# sourceMappingURL=memoryFacts.api.js.map